import { IconButton } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../../context/TokenProvider';
import BinIcon from '../../../icons/BinIcon/BinIcon';
const BinButton = (props) => {
    const tokens = useTokens();
    const style = {
        borderRadius: tokens.BorderRadius08,
        borderWidth: tokens.BorderWidth01,
        borderColor: tokens.IconPrimary,
        background: tokens.Layer01,
        minWidth: '32px',
        minHeight: '32px',
    };
    return (React.createElement(IconButton, { "data-testid": "bin_button", sx: style, size: "xs", variant: "secondary", icon: React.createElement(BinIcon, null), ...props }));
};
export default BinButton;
